import React, { useEffect, useRef } from "react";
import s from "./style.module.css";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import { scaleOrdinal } from "d3-scale";
import { range } from "d3-array";

const margin = {
  top: 10,
  right: 50,
  bottom: 10,
  left: 50,
};

const Limitations = ({
  data,
  title,
  note,
  source,
  scrollerNum,
  circleLabels,
}) => {
  // const { ref, width, height, windowSize, inView } = useVizualisation()
  const { ref, windowSize, width } = useVizualisation();
  // const height = Math.max(650, windowSize.height - 200)
  const height = windowSize.height - 200;

  const w = Math.max(width, 650) - margin.left - margin.right;
  const h = height - margin.top - margin.bottom;

  const R = Math.min(300, height / 2 - 70);

  // const circleData = [
  //   'Population',
  //   'Mobile phone users',
  //   'Smart phone users',
  //   'Tracking app users'
  // ]

  const c = scaleOrdinal().range(["white", "#31989E", "#3574B6", "#481F7C"]);

  const points = useRef([]);

  const weePeopleChars = range(65, 91).concat(range(97, 123));

  useEffect(() => {
    if (points.current.length === 0) {
      points.current = range(3000).map((d) => {
        const r = R * Math.sqrt(Math.random());
        const theta = Math.random() * 2 * Math.PI;

        const x = r * Math.cos(theta);
        const y = r * Math.sin(theta);

        return {
          x: x,
          y: y,
          c: String.fromCharCode(
            weePeopleChars[Math.floor(Math.random() * weePeopleChars.length)]
          ),
          i:
            circleLabels.length -
            Math.floor(
              Math.sqrt(x * x + y * y) / Math.floor(R / circleLabels.length)
            ),
        };
      });
    }
  }, [width, height]);

  const rings = circleLabels.map((_, i) => ({
    people: points.current.filter((d) => d.i === i + 1),
    visible: scrollerNum < i + 1,
  }));

  return (
    <Vizualisation
      title={title}
      note={note}
      source={source}
      ref={ref}
      size="large"
    >
      <svg viewBox={`0 0 ${Math.max(width, 650)} ${height}`}>
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g transform={`translate(${w / 2}, ${h / 2})`}>
            {circleLabels
              .filter((d, i) => i <= scrollerNum)
              .map((d, i) => (
                <g key={`circle-${i}`}>
                  <circle
                    r={R * ((circleLabels.length - i) / circleLabels.length)}
                    fill={c(i)}
                    opacity={i < scrollerNum ? 0.3 : 0.7}
                    stroke="white"
                    style={{ strokeWidth: 5 }}
                  />
                </g>
              ))}
            <text
              dy={-35}
              y={-R}
              className={s.label}
              fill={scrollerNum === 0 ? "black" : c(scrollerNum)}
            >
              {circleLabels[scrollerNum]}
            </text>
            {rings.map(({ visible, people }, i) => (
              <g key={`wee-${i}`} opacity={visible ? 1 : 0.3}>
                {people.map((d, i) => (
                  <text key={`wee-${i}`} className={s.wee} x={d.x} y={d.y}>
                    {d.c}
                  </text>
                ))}
              </g>
            ))}
          </g>
        </g>
      </svg>
    </Vizualisation>
  );
};

export default Limitations;
